import React from "react";
import Checkbox from "@material-ui/core/Checkbox";

import "../../../../styles.css"

export default function Usinas(props) {
    const handleChange = (event) => {
        props.setUsinas({ ...props.usinas, [event.target.name]: event.target.checked });
    };

    return (
        <>
            <div className="titles2">Usinas</div>
            <div style={{ maxHeight: 230, overflow: 'auto' }}>
                {
                    props.list_usinas.map((item, i) => {
                        return (
                            <div style={{ whiteSpace: 'pre-line' }}>
                                {props.usinas[item._id] === false || props.usinas[item._id] === true ?
                                    <>
                                        <Checkbox
                                            checked={props.usinas[item._id]}
                                            onChange={handleChange}
                                            inputProps={{ 'aria-label': 'primary checkbox' }}
                                            name={item._id}
                                        />
                                        {item.nome}
                                    </>
                                    : null
                                }
                            </div>
                        )
                    })
                }
            </div>
        </>
    )
}
